import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';

import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable, map, tap } from 'rxjs';
import { Dao } from '../dao';
import { DataLoader } from '../data-loader';
import { DataLoaderAuthentified } from '../data-loader-authentified';

@Injectable({
  providedIn: 'root',
})
export class LoanDao extends Dao {
  private loans: DataLoaderAuthentified<any[]> = new DataLoaderAuthentified<
    any[]
  >(this.getAuthentified(), user => {
    return this.httpApi.get(`/accounts/${user.accountId}/loans`);
  });

  private allLoans: DataLoaderAuthentified<any[]> = new DataLoaderAuthentified<
    any[]
  >(this.getAuthentified(), user => {
    return this.httpApi.get(`/accounts/${user.accountId}/loans?current=ALL`);
  });

  private loanCapacity: DataLoaderAuthentified<any[]> =
    new DataLoaderAuthentified<any[]>(this.getAuthentified(), user => {
      return this.httpApi.get(`/accounts/${user.accountId}/loan-capacity`);
    });

  private references: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/loans`),
  );

  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  /* Loan */
  getLoans(): Observable<any> {
    return this.loans.get();
  }
  getAllLoans(): Observable<any[]> {
    return this.allLoans.get();
  }
  getCurrentLoans(): Observable<any> {
    return this.loans
      .get()
      .pipe(map(earnings => earnings.filter(e => e.current)));
  }
  saveLoan(entity: any, reset: boolean = true): Observable<any> {
    const dto = { ...entity };
    const url = `/accounts/${entity.accountId}/loans`;
    let sub = !dto.id
      ? this.httpApi.post(url, dto)
      : this.httpApi.put(`${url}/${dto.id}`, dto);
    return sub.pipe(
      tap(() => {
        if (reset) this?.reset();
      }),
    );
  }
  simulateLoan(entity: any): Observable<any> {
    let dto = { ...entity };
    return this.httpApi
      .post(`/services/loans`, dto)
      .pipe(tap(() => this?.reset()));
  }
  deleteLoan(accountId, loanId): Observable<any> {
    return this.httpApi
      .delete(`/accounts/${accountId}/loans/${loanId}`)
      .pipe(tap(() => this?.reset()));
  }
  getLoan(accountId, loanId): Observable<any> {
    return this.httpApi.get(`/accounts/${accountId}/loans/${loanId}`);
  }
  computeLoanModel(model: any): Observable<any> {
    return this.httpApi.post(`/services/loan`, model);
  }
  getProductLoan(product: any): Observable<any> {
    return this.httpApi.get(`/products/${product}`);
  }
  searchProductsLoan(criteria: any): Observable<any> {
    return this.httpApi
      .post(`/products/search`, criteria)
      .pipe(map(res => res['content']));
  }

  /* Loan Capacity */
  getLoanCapacity(): Observable<any> {
    return this.loanCapacity.get();
  }

  computeLoanCapacity(accountId, dto: any): Observable<any> {
    return this.httpApi
      .post(`/accounts/${accountId}/loan-capacity`, dto)
      .pipe(tap(data => this.loanCapacity.setCache(data)));
  }

  /* Reference */
  getReferences(): Observable<any> {
    return this.references.get();
  }

  /* state */
  reset() {
    this.loans?.reset();
    this.allLoans?.reset();
    this.loanCapacity?.reset();
  }

  onUserChange(event: any) {
    this?.reset();
  }
}
